<template>
  <div>

     <div class="row">
      <div class="col col-md-12 col-sm-12 text-center">

        <div class="d-flex justify-content-center" v-bind:style="{display: (propView=='completo' ? 'block' : 'none')}">

          <Combo
                :itens="$global.sites_filtro_completo()"
                v-model="filtroSite"
                style="max-width:150px;margin-right:10px;display:none"
                v-if="retornaSite() !== 'Share' && retornaSite() !== 'Stream1x2' && retornaSite() !== '7live'"
              />

          <DataFiltro :value="filtroData" @change="carregarItens()" @reload="carregarItens()" v-bind:style="{display: (propView=='completo' ? 'block' : 'none')}"/>

          <input
            class="form-control inputPesquisa"
            style="max-width:80%;margin-right:10px;display:none"
            type="text"
            placeholder="Email..."
            v-model="filtroUsuario"
            @keyup="keyupFiltroUsuario"
          />

        </div>

        <hr v-bind:style="{display: (propView=='completo' ? 'block' : 'none')}" />

        <div class="rowLista">
          <div
            class="list-group-item"
            v-for="item in itens"
            :key="item.key"
            :item="item"
          >
            <div class="row">
              <div class="col col-md-12">
                
                <div class="d-flex w-100 justify-content-between">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-start">
                      <h6 class="mb-1" v-bind:style="{display: (propView=='usuario' ? 'block' : 'none'),'text-decoration': (item.excluir==true ? 'line-through' : 'none')}"><small></small>{{ item.evento.nome }}</h6>
                      <h6 class="mb-1" v-bind:style="{display: (propView=='completo' ? 'block' : 'none'),'text-decoration': (item.excluir==true ? 'line-through' : 'none')}">{{item.usuario.email}}</h6>
                      <button @click="excluir(item)" v-if="item.excluir==false" type="button" class="btn btn-outline-danger btn-sm" style="zoom: 0.6;max-height: 28px;margin-left:10px">X</button>
                    </div>
                    
                  </div>
                  <div>
                    <h6 class="mb-1" v-bind:style="{display: (propView=='completo' ? 'block' : 'none'),'text-decoration': (item.excluir==true ? 'line-through' : 'none')}">€ {{ item.valor }}</h6>
                    <h6 class="mb-1" v-bind:style="{display: (propView=='usuario' ? 'block' : 'none'),'text-decoration': (item.excluir==true ? 'line-through' : 'none')}"><small></small>€ {{ item.valor }}</h6>
                  </div>
                </div>
                <div>
                  <p class="text-secondary textoResumo d-flex w-100 justify-content-between">
                    <small v-bind:style="{display: (propView=='usuario' ? 'block' : 'none')}">Data: {{ item.evento.dataDia }}/{{ item.evento.dataMes }}/{{ item.evento.dataAno }} {{ item.evento.dataHora }}:{{ item.evento.dataMinuto }}</small>
                    <small v-bind:style="{display: (propView=='completo' ? 'block' : 'none')}">Evento: {{ item.evento.dataDia }}/{{ item.evento.dataMes }}/{{ item.evento.dataAno }} {{ item.evento.dataHora }}:{{ item.evento.dataMinuto }} - {{ item.evento.nome }}</small>
                    <small style="margin-right:3px">Lançamento: {{formatDateTime(item.dataLancamento)}}</small>
                  </p>
                </div>
              
              </div>
            </div>
          </div>
        </div>

        <p v-bind:style="{display: (propView=='completo' ? 'block' : 'none')}" style="margin-top:15px">Total de {{itens.length}} itens</p>

      </div>
    </div>

  </div>
</template>

<script>
import { api } from "@/services/api.js";

import util from "../includes/util.js";

import Combo from "../components/Combo.vue";
import DataFiltro from "../components/DataFiltro.vue";

export default {
  name: "ListEventosUsuario",
  components: { Combo, DataFiltro },
  props: { itensLimit: { type: Number, default: 50 }, propUsuario: { type: String, default: "" }, propView: { type: String, default: "usuario" } },
  methods: {
    limpar()
    {
      this.$set(this.item, "plano", "");
      this.itens = [];
      this.planos = [];
    },
    retornaSite()
    {
      return this.$site;
    },
    async carregarItensUsuario(idUsuario) {

      const responsePlano = await api.get("/evento/usuario/" + idUsuario);
      api.valid(responsePlano.data, this.$router);

      if(!responsePlano.data.erro)
      {

        this.itens = responsePlano.data.itens;

      }

    },
    async carregarItens() {

      const responsePlano = await api.get("/evento/usuarios?data=" + this.filtroData.dia + "-" + this.filtroData.mes + "-" + this.filtroData.ano);
      api.valid(responsePlano.data, this.$router);

      if(!responsePlano.data.erro)
      {

        this.itens = responsePlano.data.itens;

      }

    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      return util.formatDateTime(data);
    },
    
    async excluir(item)
    {

      if(confirm("Deseja excluir o item ?"))
      {

        const responsePlano = await api.post("/evento/usuario/excluir",{usuario:item.usuario._id,key:item.key});
        api.valid(responsePlano.data, this.$router);

        if(!responsePlano.data.erro)
        {

          if(this.propView == "usuario")
          {
            this.carregarItens(this.propUsuario);
          }else{
            this.carregarItens();
          }

        }

      }

    },keyupFiltroUsuario() {
      clearTimeout(this.timerFiltroUsuario);

      var obj = this;

      this.timerFiltroUsuario = setTimeout(function () {
        obj.carregarItens();
      }, 1000);
    },
  },
  mounted() {

    var dataAtual = new Date();
    this.filtroData.dia = 0;
    this.filtroData.mes = dataAtual.getMonth() + 1;
    this.filtroData.ano = dataAtual.getFullYear();
    
  },
  data: function () {
    return {
      //filtroTexto: "",
      filtroUsuario:"",
      filtroData:{dia:0,mes:0,ano:0},
      filtroSite:"Todos",
      //ordem:"vencimento_ASC",
      item:{plano:""},
      itens: [],
      planos: [],
      itensTotal: 0,
      editItem: null,
      timerFiltroUsuario:null
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.botaoNovo {
  margin-top: 6px;
}

</style>
